import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-years-selector',
  standalone: true,
  imports: [CommonModule, MatFormField, FormsModule, MatLabel, MatSelect, MatOption],
  templateUrl: './years-selector.component.html',
  styleUrl: './years-selector.component.scss',
})
export class YearsSelectorComponent implements OnInit, OnDestroy {
  private readonly _destroying$: Subject<void> = new Subject<void>();
  private readonly _updateYear$: EventEmitter<void> = new EventEmitter(true);

  private _years: number[] = [];
  private _selectedYear: number | undefined = undefined;
  @Input() selectedYearInput: number | undefined;
  private _availableYears: number[] | undefined = undefined;
  private _scssClassToApply: string | undefined = undefined;

  get selectedYear(): number | undefined {
    return this._selectedYear;
  }

  set selectedYear(value: number | undefined) {
    if (this._selectedYear !== value && value !== undefined) {
      this._selectedYear = value;
      this.onSelectionChange();
    }
  }

  get years(): number[] {
    return this._years;
  }

  set years(value: number[]) {
    if (this._years !== value) {
      this._years = value;
      this._updateYear$.emit();
    }
  }

  @Input()
  set availableYears(value: number[] | undefined) {
    this._availableYears = value;
    if (value && Array.isArray(value)) {
      this.years = [...value];
    }
  }

  get scssClassToApply(): string | undefined {
    return this._scssClassToApply;
  }

  @Input()
  set scssClassToApply(value: string) {
    if (this._scssClassToApply !== value) {
      this._scssClassToApply = value;
    }
  }

  get availableYears(): number[] | undefined {
    return this._availableYears;
  }

  @Output() onYearSelectionChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
    this._updateYear$.subscribe(() => {
      this._onYearsUpdate();
    });
  }

  ngOnInit(): void {
    if (this.availableYears && Array.isArray(this.availableYears)) {
      this.years = [...this.availableYears];
    } else {
      this.initializeYears();
    }

    this.setDefaultYear();
  }

  ngOnChanges(): void {
    this.selectedYear = this.selectedYearInput;
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  onSelectionChange(value: number | undefined = undefined): void {
    if (value !== undefined) {
      this.selectedYear = value;
      this.onYearSelectionChange.emit(this.selectedYear);
    } else {
      this.onYearSelectionChange.emit(this.selectedYear);
    }
  }

  private initializeYears(): void {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 2010; i--) {
      this.years.push(i);
    }
  }

  private setDefaultYear(): void {
    const currentYear = new Date().getFullYear();
    if (this.years.includes(currentYear)) {
      this.selectedYear = currentYear;
    } else {
      this.selectedYear = this.years[0];
    }
  }

  private _onYearsUpdate(): void {
    if (!this.years.includes(this.selectedYear!)) {
      this.setDefaultYear();
    }
  }
}
